import { render, staticRenderFns } from "./HeaderMenu_login.vue?vue&type=template&id=06856a3f&scoped=true"
import script from "./HeaderMenu_login.vue?vue&type=script&lang=js"
export * from "./HeaderMenu_login.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenu_login.vue?vue&type=style&index=0&id=06856a3f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06856a3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06856a3f')) {
      api.createRecord('06856a3f', component.options)
    } else {
      api.reload('06856a3f', component.options)
    }
    module.hot.accept("./HeaderMenu_login.vue?vue&type=template&id=06856a3f&scoped=true", function () {
      api.rerender('06856a3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/type_4/HeaderMenu_login.vue"
export default component.exports